module.exports = __webpack_public_path__ + "media/images/worktype_role/administrativos-d77c289608d1b2515bd10d9352969666.png";